// extracted by mini-css-extract-plugin
module.exports = {"container":"icon_container__csh6d"};